import React, { Component } from "react";
import "./usingYoti.css";
import AppStore from "../assets/button/app-store.png";
import PlayStore from "../assets/button/play-store.png";
// import YotiButton from "./yotiButton";

class UsingYoti extends Component {
  state = {};

  render() {
    // const appId = "4560cc8b-0326-4cfe-a9fb-6082083c223a";
    // const scenId = "b629aeb8-70ab-4f77-9e90-8da14c67c3f9";
    // const text = "Continue with Yoti";
    return (
      <div className="Yoti">
        <div className="container">
          <div className="row">
            <div className="col yotiPad">
              <h1 className="Sign-up-instantly-us">
                Sign up instantly using Yoti
              </h1>
              <div id="signupYoti" />
              {/* <YotiButton appId={appId} scenId={scenId} text={text} /> */}
            </div>
            <div className="col yotiPad">
              <h2 className="Get-trading"> Get trading in seconds</h2>
              <h2 className="Get-trading-in-secon">
                For this demo site, we only store your date for a month, it is
                then permanently wiped from our records
              </h2>
              <h2 className="Get-trading-in-secon">
                For Instant Identity Verification we will ask for the follow
                attributes name, age, email.
              </h2>
              <h2 className="Get-trading-in-secon">
                Don’t have Yoti, download here:
              </h2>
              <a href="https://itunes.apple.com/us/app/yoti/id983980808?ls=1&mt=8">
                <img
                  src={AppStore}
                  align="left"
                  alt=""
                  className="stores mr-2"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.yoti.mobile.android.live">
                <img
                  src={PlayStore}
                  align="left"
                  alt=""
                  className="stores mr-2"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UsingYoti;
